export enum EnvironmentEnum
{
    Development = 1,
    Internal = 2,
    Local = 3,
    Production = 4,
    Test = 5,
    Default = 0
}